import { Component, inject, input, model, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { SnackbarService } from '../../../services'
import { FileDragDirective } from './file-drag.directive'

@Component({
  selector: 'lib-file-drag',
  imports: [FileDragDirective, MatIconModule, MatButtonModule, MatTooltipModule],
  templateUrl: './file-drag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './file-drag.component.scss',
})
export class FileDragComponent {
  private readonly snachbarService = inject(SnackbarService)
  readonly file = model<File | null>(null)

  readonly label = input('Datei auswählen')
  readonly accept = input('*')
  readonly disabled = input(false)

  setFile(file?: File | null) {
    if (this.disabled()) {
      return
    }
    if (this.accept() === '*' || this.accept().includes(file?.type ?? '')) {
      this.file.set(file ?? null)
    } else {
      this.snachbarService.showError('Die ausgewählte Datei hat einen ungültigen Dateityp.')
    }
  }
}
